import { ShoppingCart } from "lucide-react";
import useCart from "@/app/lib/features/cart/cart.hook";
import Link from "next/link";
import { trackGeneric } from "@/app/lib/tracking/interactions";

const CartButton = () => {
  const { cartCount } = useCart();

  return (
    <Link href="/sepet" aria-label={cartCount > 0 ? `Sepetim (${cartCount} ürün)` : "Sepetim"} onClick={() => trackGeneric("header_cart", "click")} className="flex items-center gap-2 font-medium text-sm hover:text-main transition-all duration-300 ease-in-out">
      <div className="relative">
        <ShoppingCart className="size-6 md:size-4.75" />
        {cartCount > 0 && (
          <span className="absolute -top-1.5 -right-1.5 bg-red-500 text-white text-[9px] font-bold rounded-full min-w-4 h-4 flex items-center justify-center px-1">
            {cartCount > 99 ? "99+" : cartCount}
          </span>
        )}
      </div>
      <p className="hidden md:block">Sepetim</p>
    </Link>
  );
};

export default CartButton;
